import { Portal } from './Portal.model';

export class UserPw {
	username: string = '';
	password: string = '';

	portale: Portal = {
		pt_id: 0,
		pt_theme: '',
		pt_logo: '',
		pt_descrizione: '',
		pt_favicon: '',
		pt_connection_url: '',
		pt_db_username: '',
		pt_db_password: '',
		logo: 0,
		totalrows: 0,
		pt_isChecked: false,
	};
}
